export const load = () => ({
	title: 'Indow Safety Hardware',
	showTitle: true,
});
